<template>
  <div class="text-h1 text-center">
    USPack Delivery Tracking
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "HomePage",
});
</script>
